import { from, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { StorageService } from 'src/app/services/storage/storage.service';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptorService implements HttpInterceptor {
  constructor(
    private storage: StorageService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>> {
    return from(this.storage.get("Session_Token")).pipe(map(token => {return token}),
    switchMap(token => {
      request = request.clone({
        setHeaders: {
          'Authorization': `${token}`,
          'Content-Type': 'application/json'
        }
      });

      return next.handle(request); 
    }));
  }
}
